import {
  isAllowedShowList,
  setDateShowList,
} from '@utils/ListJourneysWaitingConfirmDelivery';
import { ReducerFnInterface } from '../../type';
import { UiStateInterface } from './ui.type';

function getDefaultState(): UiStateInterface {
  return {
    modalMonitoring: {
      isShow: false,
      flow: 'list-item',
      journeyId: '',
    },
    modalUpdatedAddress: {
      isShow: false,
      flow: 'modalMonitoring',
      journeyId: '',
    },
    modalJourneyWaitingConfirmDelivery: {
      isShow: false,
    },
    DialogUnrecognized: {
      isShow: false,
      journeyId: '',
    },
    DialogCancelJourney: {
      isShow: false,
      journeyId: '',
      depositFee: {
        tagLabel: '',
      },
    },
    DrawerProposal: {
      isShow: false,
      proposalId: '',
    },
    DialogDeliveryConfirmation: {
      isShow: false,
      journeyId: '',
    },
  };
}

export const uiReducer: ReducerFnInterface<UiStateInterface> = (
  state,
  { type, payload },
) => {
  switch (type) {
    case 'ui_modalMonitoring_set_show': {
      return {
        ...state,
        modalMonitoring: {
          isShow: payload.isShow,
          flow: payload.flow || 'list-item',
          journeyId: payload.journeyId || '',
        },
      };
    }
    case 'ui_modalUpdatedAddress_set_show': {
      return {
        ...state,
        modalUpdatedAddress: {
          isShow: payload.isShow,
          flow: payload.flow || 'modalMonitoring',
          journeyId: payload.journeyId || '',
        },
      };
    }

    case 'ui_modal_journey_waiting_confirm_delivery_set_show': {
      let showModal = false;

      if (payload.isShow && isAllowedShowList()) {
        showModal = true;
        setDateShowList();
      }

      return {
        ...state,
        modalJourneyWaitingConfirmDelivery: {
          isShow: showModal,
        },
      };
    }
    case 'ui_dialogUnrecognized_set_show': {
      return {
        ...state,
        DialogUnrecognized: {
          ...payload,
        },
      };
    }
    case 'ui_dialogDeliveryConfirmation_set_show': {
      return {
        ...state,
        DialogDeliveryConfirmation: {
          ...payload,
        },
      };
    }
    case 'ui_dialogCancelJourney_set_show': {
      return {
        ...state,
        DialogCancelJourney: {
          ...payload,
        },
      };
    }
    case 'ui_drawerProposal_set_show': {
      return {
        ...state,
        DrawerProposal: {
          ...payload,
        },
      };
    }

    default:
      return state;
  }
};

uiReducer.key = 'ui';
uiReducer.initialState = getDefaultState();
